module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#video",
      toString: function () {
        return this.url;
      }
    }